import React from "react";
import "./ProductComponent.css";
const ProductComponent = ({
  icon,
  id,
  title,
  desc,
  list = [],
}) => {
  return (
    <div key={id} className="product-container">
      <span className="product-icon">
        <img width={100} src={icon} alt="" />
      </span>
      <h5>{title}</h5>
      <small>{desc}</small>
      <div className="product-list">
        {list.map((sub) => (
          <div className="product-list-item">{sub}</div>
        ))}
      </div>
    </div>
  );
};

export default ProductComponent;
